<template>
	<div class="p4">
		<core-form-input
			size="small"
			:label="$t('status')"
			componentName="j-base-select"
			name="benefit_claims"
			v-model="form.status"
			:options="options.status"
		/>

		<!-- Button -->
		<div class="flex xs-left mt6">
			<j-button @click="onSubmit" :isLoading="isLoading">{{
				$t("save")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "../api"

/**
 * This component is smart
 * It's reposnsible for rendering prepopulated form and updating data via API
 * When update is done it emits event up to the parent
 */
export default {
	components: { CoreFormInput, JButton },

	props: {
		data: {
			type: Object,
			default: () => ({
				claimId: null,
				status: null,
				policyId: null,
				claimantId: null
			})
		}
	},

	data() {
		return {
			isLoading: false,
			form: {
				status: null,
				policyId: null,
				claimantId: null
			},
			options: {
				status: [
					{
						name: "Approved",
						value: "APPROVED"
					},
					{
						name: "Processing",
						value: "PROCESSING"
					},
					{
						name: "Rejected",
						value: "REJECTED"
					},
					{
						name: "Pending",
						value: "PENDING"
					}
				]
			}
		}
	},

	methods: {
		async onSubmit() {
			if (!this.data.claimId) return

			this.isLoading = true
			const res = await api.updateClaim({
				claimId: this.data.claimId,
				input: {
					status: this.form.status
				}
			})

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				this.isLoading = false
				return
			}

			this.$emit("updated")
			this.isLoading = false
			this.$modal.hide("updateParticulars")
		}
	},

	created() {
		// Populate form from data prop
		this.form = { ...this.data }
	}
}
</script>